import { render, staticRenderFns } from "./DatingReviewPostPage.vue?vue&type=template&id=63aae94c&scoped=true"
import script from "./DatingReviewPostPage.vue?vue&type=script&lang=js"
export * from "./DatingReviewPostPage.vue?vue&type=script&lang=js"
import style0 from "./DatingReviewPostPage.vue?vue&type=style&index=0&id=63aae94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aae94c",
  null
  
)

export default component.exports